// apps/web/src/lib/trpc.ts
import { QueryClient } from '@tanstack/react-query';

export { skipToken } from '@tanstack/react-query';

import { httpBatchLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '../../../server/src/routers';
import { SERVER_URL } from './config';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 300_000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

export const trpc = createTRPCReact<AppRouter>();
export type TrpcReact = typeof trpc;

const getTRPCUrl = () => {
  return `${SERVER_URL}/trpc`;
};

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: getTRPCUrl(),
      fetch(url, options) {
        return fetch(url, {
          ...options,
          // CRITICAL: Send cookies with tRPC requests.
          credentials: 'include',
          headers: {
            ...options?.headers,
            'Content-Type': 'application/json',
          },
        });
      },
    }),
  ],
});
